module.exports = __webpack_public_path__ + "static/sui-button-compact-8e49c3c3f23aea957d220ea72d4af92e.png";